export const iconFontAwesomeSecurityPersonThroughWindow = (
	<i className="fa-solid fa-person-through-window"></i>
);
